import {
    Grid,
    Title
} from "@mantine/core";

import {
    Field,
    useField
} from "formik";

import {ListRowElement} from "./types";


const renderElementWithLabel = (element: ListRowElement, fieldName: string) => {

    return (
        <Grid key={element.name}>
            <Grid.Col span={4}>
                <RowField name={fieldName} element={element}/>
            </Grid.Col>
            <Grid.Col span={8}>
                {element.label && (
                    <Title order={4}>
                        {element.label}
                    </Title>
                )}
            </Grid.Col>
        </Grid>
    );
};


export const ListRow = (
    {
        fieldName,
        rowIndex,
        rowElements
    }: {
        fieldName: string,
        rowIndex: number,
        rowElements: ListRowElement[]
    }) => {

    // calculate grid definition
    const defaultColspan = Math.floor(12 / rowElements.length);

    return (
        <Grid grow>
            {rowElements.map((element, elementIndex: number) => {
                const itemFieldName = `${fieldName}.${rowIndex}.${element.name}`;

                return (
                    <Grid.Col key={elementIndex} span={element.span ? element.span : defaultColspan}>
                        {(typeof element.label !== "undefined" && element.label.length > 0) ? renderElementWithLabel(element, fieldName) :
                            <RowField key={element.name} name={itemFieldName} element={element}/>}
                    </Grid.Col>
                );
            })}
        </Grid>
    );
};


export const RowField = (
    {
        name,
        element
    }: {
        name: string,
        element: ListRowElement
    }) => {

    const {
        name: fieldName,
        ...rest
    } = element

    // const [field, meta, helpers] = useField(name);
    const [meta] = useField(name);
    const {value} = meta;

    // const {setValue} = helpers;
    // console.debug(`row field: ${JSON.stringify(field)}`)
    // console.debug(`row meta: ${JSON.stringify(meta)}`)
    // console.debug(`row helpers: ${JSON.stringify(helpers)}`)

    // console.debug(`row field name:  ${name} , value: ${value}`)

    return (
        <Field
            name={name}
            value={value}
            // onChange={(value: any) => {
            //     setValue(value);
            // }}
            {...rest}
        />
    );
};


